import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { themeSelector } from 'store/users'
import { resolveTheme } from './resolveTheme'

export default function ThemeBridge() {
  const reduxTheme = useSelector(themeSelector)

  useEffect(() => {
    const mode = resolveTheme(reduxTheme)
    const root = document.documentElement

    root.style.colorScheme = mode

    const bg = mode === 'dark' ? '#131316' : '#ffffff'
    const fg = mode === 'dark' ? '#ffffff' : '#1A1A1D'
    root.style.backgroundColor = bg
    const onReady = () => {
      document.body.style.backgroundColor = bg
      document.body.style.color = fg
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onReady, { once: true })
    } else {
      onReady()
    }
  }, [reduxTheme])

  return null
}
